@if (!errorMessage) {
<div class="layout">
  @if (userLogin) {
  <aside
    class="side"
    [ngClass]="{
      close: sideNavToggleBtn,
      sideRes: showSideNav,
      langEn: _translate.getDefaultLang() == 'en'
    }"
    id="sideNav"
    #sideNav
  >
    <app-side-menu
      [sideNavToggleBtn]="sideNavToggleBtn"
      [subMenu]="subMenu"
      (toggleSubMenu)="toggleSubMenu($event)"
      (sideNavToggleBtnRes)="showSideNav = $event"
    ></app-side-menu>
    <div
      class="side-icon"
      (click)="toggleSideNav(sideNavToggleBtn ? false : true)"
    >
      <mat-icon class="material-icons-round">
        @if (_translate.getDefaultLang() == 'ar') {
        {{ sideNavToggleBtn ? "chevron_left" : "chevron_right" }}
        } @else {
        {{ sideNavToggleBtn ? "chevron_right" : "chevron_left" }}
        }
      </mat-icon>
    </div>
  </aside>
  }
  <div
    class="main"
    (click)="toggleSubMenu(false)"
    [ngClass]="{
      userLogin: userLogin,
      sideBar_toggle: userLogin && sideNavToggleBtn,
      sideRes: showSideNav
    }"
  >
    <!-- header -->
    @if (userLogin) {
    <app-header
      [sideNavToggleBtn]="sideNavToggleBtn"
      class="header"
      [route]="route"
      [ngClass]="{
        userLogin: userLogin,
        sideBar_toggle: userLogin && sideNavToggleBtn
      }"
      (sideNavToggleBtnRes)="showSideNav = $event; sideNavToggleBtn = false"
    ></app-header>
    }
    <!-- notification -->
    <app-notification></app-notification>
    <!-- main content -->
    <app-loading-layout />
    <div
      class="content"
      [ngStyle]="{
        margin: userLogin ? '' : '0',
        height: userLogin ? 'auto' : '100%'
      }"
      [ngClass]="{
        userLogin: userLogin,
        sideBar_toggle: userLogin && sideNavToggleBtn
      }"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
}
<!-- handle error message to reload page component -->
@else {
<app-reload-page [errorMessage]="errorMessage"></app-reload-page>
}
